import React, { useContext, useState,useCallback, useEffect} from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import LanguageContext from '../components/LanguageContext';
import { Modal } from "reactstrap";
import CK_en from '../resources/CK_en.json';
import CK_fr from '../resources/CK_fr.json';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../style/style.css';
import '../style/body-style.css';
import {getDate, getBaseUrl, getCurrentYear} from "../components/Utils";

function SearchDetails() {
  const { language } = useContext(LanguageContext);
  const CK = language === 'en' ? CK_en : CK_fr;
  const locale = language === 'en' ? 'en-CA' : 'fr-CA';
  document.title = CK['get_entity.title'];

  const location = useLocation();
  const navigate = useNavigate();
  const { record, searchRecord, hasEmail, hasPostalCode, hasExistingMailoutRequest} = location.state || {};

  if (record && record.entityName) {
    record.entityName = decodeURIComponent(record.entityName);
  }

  const [formData, setFormData] = useState({
    officialEmail: '',
    firstName: '',
    lastName: '',
    telephoneNumber: '',
    postalCode: '',
    email: '',
    confirm_email: '',
    legalAffiliation: '',
    documentName: '',
    documentFiler: '',
    documentYear: '',
    documentMonth: '',
    termsAndCondition: false,
    confirm_authority: false,
    useEmail: true,
    usePostalCode: false,
    useSecurityQuestions: false,
  });

  const [step, setStep] = useState('additionalInfo');
  const [showEmailFields, setShowEmailFields] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [additionalInfo, setAdditionalInfo] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalTermsAndCondition, setModalTermAndConditionOpen] = useState(false);
  const [hasErrors, setHasErrors] = useState(false);
  const [errors, setErrors] = useState({});
  const [register, setRegister] = useState('');
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [emailAddress, setEmailAddress] = useState();
  const [relationshipToEntity, setRelationshipToEntity] = useState();
  const [documentName, setDocumentName] = useState();
  const [submittedPostalCode, setSubmittedPostalCode] = useState(false);
  const [systemError, setSystemError] = useState(false);
  const [noEmailMatched, setNoEmailMatched] = useState(false);
  const [noPostalCodeMatched, setNoPostalCodeMatched] = useState(false);
  const [governingJurisdictionFr, setGoverningJurisdictionFr] = useState();

  useEffect(() => {
    if (record) {
      setRegister(record.register);
    }
    if (hasEmail) {
      setStep('email');
    } else if (hasPostalCode && !hasExistingMailoutRequest) {
      setStep('postalCode');
      handleshowEmailFields();
    } else {
      setStep('additionalInfo');
      handleAdditionalInfo();
    }
    
  }, []);
  
  useEffect(() => {
    if(hasErrors){
      validate();
    }
    document.body.setAttribute('lang', language);
    handleGoverningJurisdiction();
    if(hasErrors){
      forcusOnElementById("errorSummaryErrorsFound");
    }

  }, [language]);

  const handleTermsAndCondition = (accepted) => {
    setFormData((prevFormData) => ({ ...prevFormData, termsAndCondition: accepted }));
    setModalTermAndConditionOpen(false);
  };

  const handleshowEmailFields = () => {
    setShowEmailFields(true);
    setFormData((prevFormData) => ({
      ...prevFormData,
      useEmail: false,
      usePostalCode: true,
      useSecurityQuestions: false,
    }));
  };

  const handleAdditionalInfo = () => {
    setAdditionalInfo(true);
    setShowEmailFields(true);
    setFormData((prevFormData) => ({
      ...prevFormData,
      useEmail: false,
      usePostalCode: false,
      useSecurityQuestions: true,
    }));
  };


  const validate = useCallback(() => {
    setErrorMessage(errorMessage);
    const newErrors = {};
    let firstInvalidField = null;  // Track the first field with an error

    if (step === 'email') {
      // Email presence, format, and match validation
      if (!formData.officialEmail) {
         newErrors.officialEmail = CK["get_entity.error.missing.official_email"];
         setNoEmailMatched(false);
         if (!firstInvalidField) firstInvalidField = 'officialEmail';
      } else if (!/\S+@\S+\.\S+/.test(formData.officialEmail)) {
         newErrors.officialEmail = CK["get_entity.error.invalid_email"];
         setNoEmailMatched(false);
         if (!firstInvalidField) firstInvalidField = 'officialEmail';
      }
      //  else if (noEmailMatched) {
      //    newErrors.officialEmail = CK["get_entity.error.no_match"];
      //    setNoEmailMatched(true);
      //    if (!firstInvalidField) firstInvalidField = 'officialEmail';
      // }
   }
   
   if (step === "postalCode") {
      if (!formData.postalCode) {
         newErrors.postalCode = CK["get_entity.error.missing.postal_code.onbis-corporations"];
         setNoPostalCodeMatched(false);
         if (!firstInvalidField) firstInvalidField = 'postalCode';
         console.log("here")
      } 
      // else if (noPostalCodeMatched) {
      //    newErrors.postalCode = CK["get_entity.error.no_match1"];
      //    setNoPostalCodeMatched(true);
      //    if (!firstInvalidField) firstInvalidField = 'postalCode';
      //    console.log("here in ")
      // }
   }
  
    if (showEmailFields) {
      const emailLower = formData.email.toLowerCase();
      const confirmEmailLower = formData.confirm_email.toLowerCase();
      const officialEmailLower = formData.officialEmail.toLowerCase();
  
      if (!formData.email) {
        newErrors.email = CK["get_entity.error.missing.email"];
        if (!firstInvalidField) firstInvalidField = 'email';  // Set the first error field
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = CK["get_entity.error.invalid_email"];
        if (!firstInvalidField) firstInvalidField = 'email';  // Set the first error field
      }
  
      if (!formData.confirm_email) {
        newErrors.confirm_email = CK["get_entity.error.missing.confirm_email"];
        if (!firstInvalidField) firstInvalidField = 'confirm_email';  // Set the first error field
      } else if (emailLower !== confirmEmailLower) {
        newErrors.confirm_email = CK["get_entity.error.does_not_match"];
        if (!firstInvalidField) firstInvalidField = 'confirm_email';  // Set the first error field
      }
    }
  
    if (!formData.firstName) {
      newErrors.firstName = CK["get_entity.error.missing.first_name"];
      if (!firstInvalidField) firstInvalidField = 'firstName';  // Set the first error field
    }
  
    if (!formData.lastName) {
      newErrors.lastName = CK["get_entity.error.missing.last_name"];
      if (!firstInvalidField) firstInvalidField = 'lastName';  // Set the first error field
    }
  
    if (!formData.telephoneNumber) {
      newErrors.telephoneNumber = CK["get_entity.error.missing.telephone"];
      if (!firstInvalidField) firstInvalidField = 'telephoneNumber';  // Set the first error field
    } else if (formData.telephoneNumber.length < 12) {
      newErrors.telephoneNumber = CK["get_entity.error.invalid_telephone"];
      if (!firstInvalidField) firstInvalidField = 'telephoneNumber';  // Set the first error field
    }
  
    if (additionalInfo) {
      if (!formData.legalAffiliation) {
        newErrors.legalAffiliation = CK["get_entity.error.missing.relationship"];
        if (!firstInvalidField) firstInvalidField = 'legalAffiliation';  // Set the first error field
      }
  
      if (!formData.documentName) {
        newErrors.documentName = CK["get_entity.error.missing.last_doc_filed"];
        if (!firstInvalidField) firstInvalidField = 'documentName';  // Set the first error field
      }
  
      if (!formData.documentFiler) {
        newErrors.documentFiler = CK["get_entity.error.missing.submitter_name"];
        if (!firstInvalidField) firstInvalidField = 'documentFiler';  // Set the first error field
      }
  
      if (!formData.documentYear) {
        newErrors.documentYear = CK["get_entity.error.missing.last_doc_date_year"];
        if (!firstInvalidField) firstInvalidField = 'documentYear';  // Set the first error field
      }
  
      if (!formData.documentMonth) {
        newErrors.documentMonth = CK["get_entity.error.missing.last_doc_date_month"];
        if (!firstInvalidField) firstInvalidField = 'documentMonth';  // Set the first error field
      }
  
      if (!formData.termsAndCondition) {
        newErrors.termsAndCondition = CK["get_entity.error.err_agreement-accepted"];
        if (!firstInvalidField) firstInvalidField = 'termsAndCondition';  // Set the first error field
      }
  
      if (!formData.confirm_authority) {
        newErrors.confirm_authority = CK["get_entity.error.err_confirm_authority"];
        if (!firstInvalidField) firstInvalidField = 'confirm_authority';  // Set the first error field
      }
    }
  
    setErrors(newErrors);
    
    const hasValidationErrors = Object.keys(newErrors).length > 0 ;
    
    setHasErrors(hasValidationErrors);
    
    return {
      isValid: !hasValidationErrors,
      firstInvalidField,
    };
  }, [CK, formData, step, showEmailFields, additionalInfo]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
  
    setSubmittedPostalCode(false);
    let formattedValue = value;
    // Formating telephone number 
    if (name === "telephoneNumber") {
      let input = value.replace(/\D/g, '');
      if (input.length > 10) {
        input = input.slice(0, 10); // Limit to 10 characters
      }
  
      // Format the input as XXX-XXX-XXXX
      if (input.length > 6) {
        formattedValue = `${input.slice(0, 3)}-${input.slice(3, 6)}-${input.slice(6, 10)}`;
      } else if (input.length > 3) {
        formattedValue = `${input.slice(0, 3)}-${input.slice(3, 6)}`;
      } else {
        formattedValue = input;
      }
    }
  
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : formattedValue,
    });
  };

  const handleUsePostalCodeClick = (e) => {
    e.preventDefault();
    if (validate()) {
      setHasErrors(false);
      if(hasPostalCode && !hasExistingMailoutRequest) {
        setStep('postalCode');
        handleshowEmailFields();
      }else{
        setStep('additionalInfo');
        handleAdditionalInfo();
      }
      setErrorMessage('');
      setFormData((prevFormData) => ({
        ...prevFormData,
        useEmail: false,
        usePostalCode: hasExistingMailoutRequest?false:true,
        useSecurityQuestions: hasExistingMailoutRequest,
        officialEmail: '',
        email: '',
        confirm_email: '',
      }));
    }
  };

  const handleUseAdditionalInfo = (e) => {
    e.preventDefault();
    if (validate()) {
      setHasErrors(false);
      setFormData((prevFormData) => ({
        ...prevFormData,
        useEmail: false,
        usePostalCode: false,
        useSecurityQuestions: true,
      }));
      setStep('additionalInfo');
      setErrorMessage('');
      handleAdditionalInfo();
    }
  };

  const handleUseAdditionalInfoQuestion = (e) => {
    e.preventDefault();
      setFormData((prevFormData) => ({
        ...prevFormData,
        useEmail: false,
        usePostalCode: false,
        useSecurityQuestions: true,
      }));
      setStep('additionalInfo');
      setErrorMessage('');
      handleAdditionalInfo();
  };
  const LoadingIndicator = () => (
    <div class='ontario-loading-indicator__overlay'>
        <div class='ontario-loading-indicator'>
            <svg class='ontario-loading-indicator__spinner' viewBox="25 25 50 50" xmlns='http://www.w3.org/2000/svg'>
                <circle cx="50" cy="50" r="20" fill="none" stroke-width="4" />
            </svg>
            <p></p>
        </div>
    </div>
    );

    const handleOnSubmit = async (e) => {
      e.preventDefault();
      
      const { isValid, firstInvalidField } = validate();
      
      if (isValid) {
        setSubmittedPostalCode(true);
       
        // Proceed with form submission as you already have in your code
        const requestBody = {
          entityIdentifier: record.entityIdentifier,
          register: register,
          email: formData.useEmail ? formData.officialEmail : formData.email,
          postalCode: formData.postalCode,
          firstName: formData.firstName,
          lastName: formData.lastName,
          useEmail: formData.useEmail,
          usePostalCode: formData.usePostalCode,
          useSecurityQuestions: formData.useSecurityQuestions,
          telephoneNumber: formData.telephoneNumber,
          legalAffiliation: formData.legalAffiliation,
          documentName: formData.documentName,
          documentFiler: formData.documentFiler,
          documentYear: formData.documentYear,
          documentMonth: formData.documentMonth    
        };
    
        try {
          setIsLoading(true);
          const response = await fetch(getBaseUrl(process.env.REACT_APP_ENV) + '/requestCompanyKey', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody),
          });
    
          setIsLoading(false);
    
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
    
          const data = await response.json();
          const serverStatusCode = data.status.additionalStatusList[0].serverStatusCode;
    
          if (serverStatusCode && serverStatusCode.includes('CK_API_BIZ_E10001')) {
            setNoEmailMatched(true);
            setHasErrors(true);
          } else if (serverStatusCode && serverStatusCode.includes('CK_API_BIZ_E10002')) {
            setNoPostalCodeMatched(true);
            setHasErrors(true);
          } else if (serverStatusCode && (
            serverStatusCode.includes('CK_API_BIZ_I30001') 
            || serverStatusCode.includes('CK_API_BIZ_I30002') 
            || serverStatusCode.includes('CK_API_BIZ_I30003') )) {
            navigate('/RequestSubmitted', { state: { record, searchRecord, formData, serverStatusCode } });
          } else {
            setErrorMessage(data.status.additionalStatusList[0].statusDescription);
            setSystemError(true);
          }
        } catch (error) {
          console.error('There was a problem with the fetch operation:', error);
          setErrorMessage('There was an error processing your request.');
          setSystemError(true);
          setIsLoading(false);
        }
      } else {
        // If validation fails, focus on the first invalid field
        window.scrollTo(0, 0);
        console.log("First invalid field:", firstInvalidField);
        if (firstInvalidField) {
            forcusOnElementByName(firstInvalidField);
        } else {
            console.log("No invalid field found.");
        }

      }
    };
    
  const renderField = (label, value) => (
    <div className="ontario-row get-entity__entity-info" tabIndex="0">
      <div className="get-entity__entity-info__col1">{label}</div>
      <div className="get-entity__entity-info__col2">{value}</div>
    </div>
  );

  const handleFirstNameChange = (e) => {
    let firstNameValue = e.target.value;
    setFirstName(firstNameValue);
  };

  const handleLastNameChange = (e) => {
    let lastNameValue = e.target.value;
    setLastName(lastNameValue);
  };

  const handleEmailAddressChange = (e) => {
    let emailAddressValue = e.target.value;
    setEmailAddress(emailAddressValue);
  };

  const handleRelationshipToEntityChange = (e) => {
    let relationshipToEntityValue = e.target.value;
    setRelationshipToEntity(relationshipToEntityValue);
  };

  const handleDocumentNameChange = (e) => {
    let docName = e.target.value;
    setDocumentName(docName);
  };

  const getYearOptions = () => {
    console.log('currentYear=' + getCurrentYear());
    const yearOptions = [];
    for (let i = getCurrentYear(); i >= 1990; i--) {
      yearOptions.push(<option value={i}>{i}</option>);
    }
    return yearOptions;
  };

  const handleSystemErrorRetry = () => {
    setSystemError(false);
  };

  const getGoverningJurisdiction = () => {
    if(language === 'en'){
      return searchRecord.governingJurisdiction;
    }else if(language == 'fr'){
      return governingJurisdictionFr;
    }
  };

  const handleGoverningJurisdiction = async () => {
    if(language == 'fr' && !governingJurisdictionFr){
      try {
          setIsLoading(true);
          const response = await fetch(getBaseUrl(process.env.REACT_APP_ENV) + '/searchEntities', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                searchFor: record.entityIdentifier,
                exactMatch: false,
                language: 'fr'
            }),
          });
          
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const data = await response.json();
          if(data.entities && data.entities[0]){
            setGoverningJurisdictionFr(data.entities[0].governingJurisdiction);
          }
      } catch (error) {
          console.error('There was a problem with the fetch operation:', error);
          setSystemError(true);
      } finally {
          setIsLoading(false);
      }
    }    
  };

  const callbackReference = useCallback(element=> {
    if (element) {
      element.focus();
    }
  }, []);

  const forcusOnElementById = (id) => {
    let theElementById  = document.getElementById(id);
    if(theElementById){
      theElementById.focus();
      theElementById.scrollIntoView();
    }
  }

  const forcusOnElementByName = (name) => {
    let theElementByName  = document.getElementsByName(name);
    if(theElementByName){
      theElementByName[0].focus();
      theElementByName[0].scrollIntoView();
    }
  }

  // Utility function to sort options by label for French
const getSortedOptions = (options, lang) =>
  lang === 'fr'
    ? [...options].sort((a, b) => a.label.localeCompare(b.label, 'fr'))
    : options;

const relationshipOptions = [
  { value: "1", label: CK["get_entity.relationship.option1"] },
  { value: "2", label: CK["get_entity.relationship.option2"] },
  { value: "3", label: CK["get_entity.relationship.option3"] },
  { value: "4", label: CK["get_entity.relationship.option4"] },
  { value: "5", label: CK["get_entity.relationship.option5"] },
  { value: "6", label: CK["get_entity.relationship.option6"] },
  { value: "7", label: CK["get_entity.relationship.option7"] },
  { value: "8", label: CK["get_entity.relationship.option8"] },
  { value: "9", label: CK["get_entity.relationship.option9"] }
];

const lastDocFiledOptions = [
  { value: "1", label: CK["get_entity.last_doc_filed.option1"] },
  { value: "2", label: CK["get_entity.last_doc_filed.option2"] },
  { value: "3", label: CK["get_entity.last_doc_filed.option3"] },
  { value: "4", label: CK["get_entity.last_doc_filed.option4"] },
  { value: "5", label: CK["get_entity.last_doc_filed.option5"] },
  { value: "6", label: CK["get_entity.last_doc_filed.option6"] },
  { value: "7", label: CK["get_entity.last_doc_filed.option7"] },
  { value: "8", label: CK["get_entity.last_doc_filed.option8"] },
  { value: "9", label: CK["get_entity.last_doc_filed.option9"] },
  { value: "10", label: CK["get_entity.last_doc_filed.option10"] },
  { value: "11", label: CK["get_entity.last_doc_filed.option11"] },
  { value: "12", label: CK["get_entity.last_doc_filed.option12"] },
  { value: "13", label: CK["get_entity.last_doc_filed.option13"] },
  { value: "14", label: CK["get_entity.last_doc_filed.option14"] }
];

const sortedRelationshipOptions = getSortedOptions(relationshipOptions, language);
const sortedLastDocFiledOptions = getSortedOptions(lastDocFiledOptions, language);

  return (
    <div className="main-content">
      <Header />
      { systemError && 
        <>
          <div className="ontario-row" tabIndex="0">
            <br/>
            {CK["entity_search.search_results.ws_error.explanation"]}
            <br/><br/>
          </div>
          <div className="ontario-row">
            <a href="#/SearchDetails" tabIndex="0" role="button" className="ontario-link" id="sytem-error-retry" onClick={handleSystemErrorRetry}>
              {CK["entity_search.search_results.explain_page.retry"]}
            </a>
            <br/><br/><br/>
          </div>
        </>
      }
      {!systemError && 
      <>
      <div className="ontario-row">
        <Link to="/" className="ontario-button ontario-button--tertiary" title={CK["footer.back1"]}>
          <svg className="svg-icon ontario-icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" width="24" height="24" aria-hidden="true">
            <path d="M15.4 7.4L14 6l-6 6 6 6 1.4-1.4-4.58-4.6 4.58-4.6z"/>
          </svg>
          {CK["footer.back"]}
        </Link>
      </div>
      <div className='ontario-row'>
      {hasErrors && (
        <div className="ontario-alert ontario-alert--error">
          <div className="ontario-alert__header">
            <div className="ontario-alert__header-icon">
              <img src="assets/icons/svg/ontario-icon-alert-error.svg" className="ontario-icon" alt="Error Icon" />
              <span tabIndex="0" className="ontario-alert__header-title ontario-h4">
                {CK["get_entity.error.summary.problem"]}
              </span>
            </div>
          </div>
          <div className="ontario-alert__body">
            <p id="errorSummaryErrorsFound" tabIndex="0" ref={callbackReference}>
              {CK["get_entity.error.summary.errors_found"]}
            </p>
            <ul>
              {Object.entries(errors).map(([field, error]) => (
                <li key={field}>
                  <a href={`#/SearchDetails`} onClick={() => forcusOnElementByName(field)}>
                    {error}
                  </a>
                </li>
              ))}
              {noEmailMatched && step === 'email' && (
                <li>
                  <div style={{"color":"#cd0000"}}>
                     {CK['get_entity.error.no_match']}
                     <a href="#" id="use_postal_code_link" style={{"color":"#06c"}} onClick={handleUsePostalCodeClick}>
                       {CK['get_entity.error.no_match_email2']}
                     </a>
                     {CK['get_entity.error.no_match_email3']}
                  </div>
                </li>
              )}
              {noPostalCodeMatched && step === 'postalCode' && (
                <li>
                  <div style={{"color":"#cd0000"}}>
                    {CK['get_entity.error.no_match1']}
                    <a href="#" id="use_postal_code" style={{"color":"#06c"}} tabIndex={0} onClick={handleUseAdditionalInfo}>
                      {CK['get_entity.error.no_match_postalcode2']}
                    </a>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </div>
        )}
      </div>

      <div className="get-entity__container">
        <div className="ontario-row">
          <span className="ontario-label ontario-label--heading autofocus" tabIndex="0" style={{marginBottom: '5px', marginTop: '10px'}}>
            {CK["get_entity.header"]}
          </span>
        </div>

        {register === 'onbis-partnerships' && (
          <>
            {renderField(CK["get_entity.label.name.onbis-partnerships"], record.entityName)}
            {renderField(CK["get_entity.label.identifier.onbis-partnerships"], record.entityIdentifier)}
            {renderField(CK["get_entity.label.date.onbis-partnerships"], getDate(searchRecord.registrationDate,locale))}
            {renderField(CK["get_entity.label.entity_type.onbis-partnerships"], CK['get_entity.entity_type.' + searchRecord.entityType])}
            {renderField(CK["get_entity.label.status.onbis-partnerships"], CK['entity_search.search_results.status.' + searchRecord.entityStatus])}
            {renderField(CK["get_entity.label.inactive_date.onbis-partnerships"], getDate(record.inactiveDate,locale))}
            {renderField(CK["get_entity.label.address.onbis-partnerships"], searchRecord.registeredHeadOfficeAddress)}
          </>
        )}

        {register === 'onbis-corporations' && (
          <>
            {renderField(CK["get_entity.label.name.onbis-corporations"], record.entityName)}
            {renderField(CK["get_entity.label.identifier.onbis-corporations"], record.entityIdentifier)}
            {renderField(CK["get_entity.label.date.onbis-corporations"], getDate(searchRecord.registrationDate,locale))}
            {renderField(CK["get_entity.label.entity_type.onbis-corporations"], CK['get_entity.entity_type.' + searchRecord.entityType])}
            {renderField(CK["get_entity.label.status.onbis-corporations"], CK['entity_search.search_results.status.' + searchRecord.entityStatus])}
            {renderField(CK["get_entity.label.governing_jurisdiction.onbis-corporations"], getGoverningJurisdiction())}
            {renderField(CK["get_entity.label.address.onbis-corporations"], searchRecord.registeredHeadOfficeAddress)}
          </>
        )}

        {register === 'onbis-businessnames' && (
          <>
            {renderField(CK["entity_search.search_results.register.onbis-businessnames"], record.entityName)}
            {renderField(CK["get_entity.label.identifier.onbis-partnerships"], record.entityIdentifier)}
            {renderField(CK["get_entity.label.date.onbis-partnerships"], getDate(searchRecord.registrationDate,locale))}
            {renderField(CK["get_entity.label.entity_type.onbis-businessnames"], CK['get_entity.entity_type.' + searchRecord.entityType])}
            {renderField(CK["get_entity.label.status.onbis-businessnames"], CK['entity_search.search_results.status.' + searchRecord.entityStatus])}
            {renderField(CK["get_entity.label.address.onbis-partnerships"], searchRecord.registeredHeadOfficeAddress)}
          </>
        )}
          <br />
          
          {step === 'additionalInfo' && hasExistingMailoutRequest && 
            <>
              <div tabIndex="0" className="ontario-row">{CK['get_entity.form_info.existing_entity']}</div>
          <br />
            </>
          }

          <div className="get-entity__form">
            {step === 'email' && (
              <>
              <div className="ontario-row">
                <p tabIndex="0">
                  {CK["get_entity.confirm_official_email"]}
                </p>
              </div>
              
                <div className="ontario-row">
                  <label  for="official_email" className="ontario-label required">
                    {CK["get_entity.official_email"]}
                  </label>
                  <div className='ontario-form-group'>
                    {/* Error message container */}
                    <div className={`ontario-error-messaging ${!errors.officialEmail ? 'ontario-error__hidden' : ''}`}>
                    <span className="ontario-error-messaging__icon">
                      <img src="assets/icons/svg/ontario-icon-alert-error.svg" className="ontario-icon" alt="Error Icon" />
                    </span>
                    <span className="ontario-error-messaging__content" tabIndex={0}>{errors.officialEmail}</span>
                  </div>

                  <input
                    className={`ontario-input ${errors.officialEmail ? 'ontario-input__error' : ''}`}
                    type="text"
                    id="official_email"
                    name="officialEmail"
                    value={formData.officialEmail}
                    onChange={handleInputChange}
                  />
                 
                </div>
                </div>
              </>
            )}

            {step === 'postalCode' && (
              <>
              {(register === 'onbis-businessnames' || register === 'onbis-partnerships') && (
                <>
                
                  <div className="ontario-row">
                    <p tabIndex="0">
                      {CK["get_entity.confirm_postal_code.onbis-partnerships"]}
                    </p>
                    {(!submittedPostalCode || !formData.postalCode) && (
                    <p className="error-message">
                      <span tabIndex={0}>{CK["get_entity.confirm_no_postal_code.onbis-businessnames"]}</span> <a href="#" id="use_postal_code" onClick={handleUseAdditionalInfoQuestion}>{CK["get_entity.error.goto_additional_questions"]}</a>&nbsp;
                      <span tabIndex={0}>{CK["get_entity.to_request_company_key"]} </span>
                    </p>     
                    )}           
                  </div>   
                               
                </>
              )}

              {register === 'onbis-corporations' && (
                <>
                 
                    <div className="ontario-row">
                      <p tabIndex="0">
                        {CK["get_entity.confirm_postal_code.onbis-corporations"]}
                      </p>
                      {(!submittedPostalCode || !formData.postalCode) && (
                        <p className="error-message">
                          <span tabIndex={0}>{CK["get_entity.confirm_no_postal_code.onbis-corporations"]} </span> 
                          <a href="#" id="use_postal_code" onClick={handleUseAdditionalInfoQuestion}>{CK["get_entity.error.goto_additional_questions"]}</a>&nbsp;
                          <span tabIndex={0}>{CK["get_entity.to_request_company_key"]}</span>
                        </p>
                      )}
                    </div>
                </>
              )}


              {/* <div className="ontario-row">
                <p
                  tabIndex="0"
                  dangerouslySetInnerHTML={{
                    __html: CK["get_entity.confirm_no_postal_code.onbis-corporations"],
                  }}
                  onClick={handleUseAdditionalInfo}
                />
              </div> */}
                <div className="ontario-row">
                  <label for="postal_code" className="ontario-label required">
                    {CK["get_entity.postal_code.onbis-corporations"]}
                  </label>
                  <div className='ontario-form-group'>
                    {/* Error message container */}
                    <div className={`ontario-error-messaging ${!errors.postalCode ? 'ontario-error__hidden' : ''}`}>
                    <span className="ontario-error-messaging__icon">
                      <img src="assets/icons/svg/ontario-icon-alert-error.svg" className="ontario-icon" alt="Error Icon" />
                    </span>
                    <span className="ontario-error-messaging__content" tabIndex={0}>{errors.postalCode}</span>
                  </div>

                  <input
                    className={`ontario-input ${errors.postalCode ? 'ontario-input__error' : ''}`}
                    type="text"
                    id="postal_code"
                    name="postalCode"
                    value={formData.postalCode}
                    onChange={handleInputChange}
                  />

                    {/* Additional error message container (if needed) */}
                    <div tabIndex={0} className="error_message hide" id="postal_code_missing" style={{ display: errors.postalCode ? 'block' : 'none' }}>
                  {CK["get_entity.error.missing.postal_code"]}
                </div>
                </div>
              </div>
              </>
            )}

            <div className="ontario-row">
            <p tabIndex="0">
              {CK["get_entity.form_info"]}
            </p>
            </div>

            <div className="ontario-row">
              <label for="first_name" className="ontario-label required">
                {CK["get_entity.first_name"]}
              </label>
              <div className={`ontario-error-messaging ${!errors.firstName ? 'ontario-error__hidden' : ''}`}>
                    <span className="ontario-error-messaging__icon">
                      <img src="assets/icons/svg/ontario-icon-alert-error.svg" className="ontario-icon" alt="Error Icon" />
                    </span>
                    <span className="ontario-error-messaging__content" tabIndex={0}>{errors.firstName}</span>
              </div>
              <input
               className={`ontario-input ${errors.firstName ? 'ontario-input__error' : ''}`}
                type="text"
                id="first_name"
                name="firstName"
                value={formData.firstName}
                onChange={function(event){ handleInputChange(event); handleFirstNameChange(event);}}
                maxLength="25"
              />
            
            </div>

            <div className="ontario-row">
              <label for="last_name" className="ontario-label required">
                {CK["get_entity.last_name"]}
              </label>
              <div className={`ontario-error-messaging ${!errors.lastName ? 'ontario-error__hidden' : ''}`}>
                    <span className="ontario-error-messaging__icon">
                      <img src="assets/icons/svg/ontario-icon-alert-error.svg" className="ontario-icon" alt="Error Icon" />
                    </span>
                    <span className="ontario-error-messaging__content" tabIndex={0}>{errors.lastName}</span>
                  </div>
              <input
                className={`ontario-input ${errors.lastName ? 'ontario-input__error' : ''}`}
                type="text"
                id="last_name"
                name="lastName"
                value={formData.lastName}
                onChange={function(event){ handleInputChange(event); handleLastNameChange(event);}} 
                maxLength="25"
              />
            </div>

            <div className="ontario-row">
              <label for="telephone" className="ontario-label required">
                {CK["get_entity.telephone"]}
              </label>
              <div className={`ontario-error-messaging ${!errors.telephoneNumber ? 'ontario-error__hidden' : ''}`}>
                    <span className="ontario-error-messaging__icon">
                      <img src="assets/icons/svg/ontario-icon-alert-error.svg" className="ontario-icon" alt="Error Icon" />
                    </span>
                    <span className="ontario-error-messaging__content" tabIndex={0}>{errors.telephoneNumber}</span>
                  </div>
              <input
                className={`ontario-input ${errors.telephoneNumber ? 'ontario-input__error' : ''}`}
                type="text"
                id="telephone"
                name="telephoneNumber"
                value={formData.telephoneNumber}
                onChange={handleInputChange}
              />
            </div>
            
            {showEmailFields && (
              <>
              <div className="ontario-row">
              <label for="email" className="ontario-label required">
                {CK["get_entity.email"]}
              </label>
              <div className={`ontario-error-messaging ${!errors.email ? 'ontario-error__hidden' : ''}`}>
                    <span className="ontario-error-messaging__icon">
                      <img src="assets/icons/svg/ontario-icon-alert-error.svg" className="ontario-icon" alt="Error Icon" />
                    </span>
                    <span className="ontario-error-messaging__content" tabIndex={0}>{errors.email}</span>
              </div>
              <input
                className={`ontario-input ${errors.email ? 'ontario-input__error' : ''}`}
                type="text"
                id="email"
                name="email"
                value={formData.email}
                onChange={function(event){ handleInputChange(event); handleEmailAddressChange(event);}}
              />
            </div>

            <div className="ontario-row">
              <label for="confirm_email" className="ontario-label required">
                {CK["get_entity.confirm_email"]}
              </label>
              <div className={`ontario-error-messaging ${!errors.confirm_email ? 'ontario-error__hidden' : ''}`}>
                    <span className="ontario-error-messaging__icon">
                      <img src="assets/icons/svg/ontario-icon-alert-error.svg" className="ontario-icon" alt="Error Icon" />
                    </span>
                    <span className="ontario-error-messaging__content" tabIndex={0}>{errors.confirm_email}</span>
              </div>
              <input
                className={`ontario-input ${errors.confirm_email ? 'ontario-input__error' : ''}`}
                type="text"
                id="confirm_email"
                name="confirm_email"
                value={formData.confirm_email}
                onChange={handleInputChange}
              />
            </div>       
              </>
            )}
              {additionalInfo && (
              <>
                <div className="ontario-row"> 
                  <label for="relationship" className="ontario-label required">
                    {CK["get_entity.relationship"]}<span className="org_name">{record.entityName} </span> 
                  </label>
                  <div className={`ontario-error-messaging ${!errors.legalAffiliation ? 'ontario-error__hidden' : ''}`}>
                    <span className="ontario-error-messaging__icon">
                      <img src="assets/icons/svg/ontario-icon-alert-error.svg" className="ontario-icon" alt="Error Icon" />
                    </span>
                    <span className="ontario-error-messaging__content" tabIndex={0}>{errors.legalAffiliation}</span>
                  </div>
                  <select
                    className={`ontario-input ontario-dropdown ${errors.legalAffiliation ? 'ontario-input__error' : ''}`}
                    id="relationship"
                    name="legalAffiliation"
                    value={formData.legalAffiliation}
                    onChange={function(event){ handleInputChange(event); handleRelationshipToEntityChange(event);}} 
                    style={{ maxWidth: '30rem' }}
                  >
                    <option value="">{CK["get_entity.please_select"]}</option>
                    {sortedRelationshipOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>

                <span class="ontario-row ontario-h2">
                  <span class="ontario-label ontario-label--heading" tabindex="0"> {CK["get_entity.last_doc_filed.header"]} <span class="org_name">{record.entityName}</span></span>
                </span>

                <div className="ontario-row">
                  <label for="last_doc_filed" className="ontario-label required">
                    {CK["get_entity.last_doc_filed"]} <span className="org_name">{record.entityName}</span>?
                  </label>
                  <div className={`ontario-error-messaging ${!errors.documentName ? 'ontario-error__hidden' : ''}`}>
                    <span className="ontario-error-messaging__icon">
                      <img src="assets/icons/svg/ontario-icon-alert-error.svg" className="ontario-icon" alt="Error Icon" />
                    </span>
                    <span className="ontario-error-messaging__content" tabIndex={0}>{errors.documentName}</span>
                  </div>
                  <select
                    className={`ontario-input ontario-dropdown ${errors.documentName ? 'ontario-input__error' : ''}`}
                    id="last_doc_filed"
                    name="documentName"
                    value={formData.documentName}
                    onChange={function(event){ handleInputChange(event); handleDocumentNameChange(event);}} 
                    style={{ maxWidth: '30rem' }}
                  >
                    <option value="">{CK["get_entity.please_select"]}</option>
                    {sortedLastDocFiledOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
                <div className='ontario-row'>
                <label id="submitter_name_label"  for="submitter_name" class="ontario-label required">
                  {CK['get_entity.submitter_name1']}
                  {documentName  &&  <span class="last_doc_filed"> {CK["get_entity.last_doc_filed.option" + documentName]} </span>}
                  {!documentName &&  <span class="invalid">{CK['get_entity.select_last_doc_filed']}</span>}
                  {CK['get_entity.submitter_name2']}<span class="org_name">{record.entityName}</span>? 
                </label>
                <p style={{marginBottom: '0px'}} tabIndex={0}>{CK["get_entity.help.submitter_name"]} <span class="org_name">{record.entityName}</span>.</p>
                <div className={`ontario-error-messaging ${!errors.documentFiler ? 'ontario-error__hidden' : ''}`}>
                    <span className="ontario-error-messaging__icon">
                      <img src="assets/icons/svg/ontario-icon-alert-error.svg" className="ontario-icon" alt="Error Icon" />
                    </span>
                    <span className="ontario-error-messaging__content" tabIndex={0}>{errors.documentFiler}</span>
                  </div>
                <input className={`ontario-input ${errors.documentFiler ? 'ontario-input__error' : ''}`}
                  type="text" 
                  id="submitter_name" 
                  name="documentFiler" 
                  value={formData.documentFiler}
                  onChange={handleInputChange}
                  style={{ maxWidth: '30rem' }}
                  maxLength="50">
                </input>
                </div>
                <div class="ontario-row" style={{marginBottom: '2px'}}> 
                  <label for="last_doc_date_year" class="ontario-label required">
                    {CK['get_entity.last_doc_date1']} 
                    {documentName  &&  <span class="last_doc_filed"> {CK["get_entity.last_doc_filed.option" + documentName]} </span>}
                    {!documentName &&  <span class="invalid">{CK['get_entity.select_last_doc_filed']}</span>}
                    {CK['get_entity.last_doc_date2']}
                  </label>
                  <div id="last_doc_date" class="ontario-date__group">
                    <div class="ontario-date__group-input">
                    <div className={`ontario-error-messaging ${!errors.documentYear ? 'ontario-error__hidden' : ''}`}>
                      <span className="ontario-error-messaging__icon">
                        <img src="assets/icons/svg/ontario-icon-alert-error.svg" className="ontario-icon" alt="Error Icon" />
                      </span>
                      <span className="ontario-error-messaging__content" tabIndex={0}>{errors.documentYear}</span>
                    </div>
                      <select className={`ontario-input ontario-dropdown ${errors.documentYear ? 'ontario-input__error' : ''}`} id="last_doc_date_year" name="documentYear" 
                       value={formData.documentYear}
                       onChange={handleInputChange}                       
                       style={{ maxWidth: '30rem' }}                    
                    >
                        <option value="">{CK["get_entity.last_doc_date.year"]}</option>
                        {getYearOptions()}
                      </select>
                    </div>
                    <div class="ontario-date__group-input">
                    <div className={`ontario-error-messaging ${!errors.documentMonth ? 'ontario-error__hidden' : ''}`}>
                      <span className="ontario-error-messaging__icon">
                        <img src="assets/icons/svg/ontario-icon-alert-error.svg" className="ontario-icon" alt="Error Icon" />
                      </span>
                      <span className="ontario-error-messaging__content" tabIndex={0}>{errors.documentMonth}</span>
                    </div>
                      <select aria-label="Month" className={`ontario-input ontario-dropdown ${errors.documentMonth ? 'ontario-input__error' : ''}`} id="last_doc_date_month" name="documentMonth" value={formData.documentMonth}                     
                      onChange={handleInputChange}
                      style={{ maxWidth: '30rem' }}
                      > 
                      <option value="">{CK["get_entity.last_doc_date.month"]}</option> 
                      <option value="1">{CK["get_entity.date.month.1"]}</option> 
                      <option value="2">{CK["get_entity.date.month.2"]}</option> 
                      <option value="3">{CK["get_entity.date.month.3"]}</option> 
                      <option value="4">{CK["get_entity.date.month.4"]}</option> 
                      <option value="5">{CK["get_entity.date.month.5"]}</option> 
                      <option value="6">{CK["get_entity.date.month.6"]}</option> 
                      <option value="7">{CK["get_entity.date.month.7"]}</option> 
                      <option value="8">{CK["get_entity.date.month.8"]}</option> 
                      <option value="9">{CK["get_entity.date.month.9"]}</option> 
                      <option value="10">{CK["get_entity.date.month.10"]}</option> 
                      <option value="11">{CK["get_entity.date.month.11"]}</option> 
                      <option value="12">{CK["get_entity.date.month.12"]}</option> 
                      </select>
                    </div>  
                  </div>
                  <br />
                  <div className={`ontario-error-messaging ${!errors.termsAndCondition ? 'ontario-error__hidden' : ''}`}>
                    <span className="ontario-error-messaging__icon">
                      <img src="assets/icons/svg/ontario-icon-alert-error.svg" className="ontario-icon" alt="Error Icon" />
                    </span>
                    <span className="ontario-error-messaging__content" tabIndex={0}>{errors.termsAndCondition}</span>
                  </div>
                 <div class="ontario-checkboxes__item" id="access_agreement">

                  <input
                    tabindex="0"
                    class="ontario-input ontario-checkboxes__input"
                    name="termsAndCondition"
                    id="agreement-accepted"
                    type="checkbox"
                    onChange={() => setModalTermAndConditionOpen(true)}
                    checked={formData.termsAndCondition}
                  />
                  <label class="ontario-checkboxes__label" for="agreement-accepted" tabIndex={0}>
                    {CK["get_entity.access_agreement"]}
                    <a id="access_agreement_link"  onClick={() => setModalTermAndConditionOpen(true)}> 
                      {CK["get_entity.access_agreement2"]}
                    </a>
                    .
                   {CK["get_entity.label.required"]}
                  </label>
                 </div> 

                <div className={`ontario-error-messaging ${!errors.confirm_authority ? 'ontario-error__hidden' : ''}`}>
                    <span className="ontario-error-messaging__icon">
                      <img src="assets/icons/svg/ontario-icon-alert-error.svg" className="ontario-icon" alt="Error Icon" />
                    </span>
                    <span className="ontario-error-messaging__content" tabIndex={0}>{errors.confirm_authority}</span>
                </div>
              <div class="ontario-checkboxes__item">
                <input 
                  class="ontario-input ontario-checkboxes__input" 
                  name="confirm_authority" 
                  id="confirm_authority" 
                  type="checkbox" 
                  value="1"
                  checked={formData.confirm_authority} 
                  onChange={handleInputChange} 
                  tabIndex={0}
                />
                <label for="confirm_authority" class="ontario-checkboxes__label" tabIndex={0}> 
                  {CK["get_entity.confirm_authority"]}, 
                  {(formData.firstName && formData.lastName) &&  <span class="authority_name"> {formData.firstName} {formData.lastName}</span>}
                  {(!formData.firstName || !formData.lastName) &&  <span style={{ color: '#cd0000' }}>{CK['get_entity.enter_name']}</span>}
                  , {CK["get_entity.confirm_authority2"]} 
                  <span class="org_name"> {record.entityName}</span> {CK["get_entity.confirm_authority3"]}
                  <span class="authority_email"> 
                  {emailAddress &&  <span class="authority_name"> {emailAddress}</span>}
                  {!emailAddress &&  <span style={{ color: '#cd0000' }}>{CK['get_entity.enter_email']}</span>}
                  </span>. {CK["get_entity.confirm_authority4"]} 
                  <span class="org_name"> {record.entityName}</span> {CK["get_entity.confirm_authority5"]}
                  <span class="authority_relationship"> 
                  {relationshipToEntity &&  <span class="authority_name"> {CK["get_entity.relationship.option" + relationshipToEntity]}</span>}
                  {!relationshipToEntity &&  <span style={{ color: '#cd0000' }}>{CK['get_entity.please_select_relationship']}</span>}
                  </span>, 
                  {CK["get_entity.confirm_authority6"]} {CK["get_entity.label.required"]}
                </label>
                
              </div>

              </div>

              </>
            )}
            <Modal
              isOpen={modalTermsAndCondition}
              onRequestClose={() => setModalTermAndConditionOpen(false)}
              className="TandCmodal"
            >
              <div>
                <div tabIndex={0} className="modal-header">
                  <b>{CK["get_entity.access_agreement.header"]}</b>
                  <button
                      aria-label="Close"
                      className="btn-close"
                      onClick={() => setModalTermAndConditionOpen(false)}
                      type="button"
                  >
                    <img src="images/ontario-icon-close.svg" alt="Icon close" />
                  </button>
                </div>
                <div className="modal-body scrollable-modal-body">
                <div id="access-agreement__body" className="ontario-overlay__body" tabIndex="0" dangerouslySetInnerHTML={{ __html: CK["get_entity.access_agreement.body"] }} />
                <div className="ontario-row" style={{"borderTop":"solid 1px gray"}}>
                  <div className="ontario-column" style={{"paddingTop":"15px"}}>
                    <button
                      className="ontario-button ontario-button--secondary"
                      onClick={() => handleTermsAndCondition(false)}
                    >
                      {CK["get_entity.access_agreement.decline"]}
                    </button>
                  </div>
                  <div className="ontario-column" style={{"paddingTop":"15px", "textAlign":"right"}}>
                    <button
                      className="ontario-button ontario-button--primary"
                      onClick={() => handleTermsAndCondition(true)}
                    >
                      {CK["get_entity.access_agreement.accept"]}
                    </button>
                  </div>
                </div>
                </div>
              </div>
            </Modal>
    
            <div className="error_message hide" id="telephone_missing">
              {CK["get_entity.error.telephone_missing"]}
            </div>
          </div>

          {/* <div className="error_message hide" id="official_email_does_not_match">
            <a href="use_postal_code" id="use_postal_code"></a>
          </div>

          <div className="error_message hide" id="postal_code_does_not_match" tabIndex="0">
            {CK["get_entity.error.postal_code_does_not_match"]} <a href="use_security_questions" id="use_security_questions">{CK["get_entity.link.use_security_questions"]}</a>
          </div>

          <div className="error_message hide" id="invalid_telephone" tabIndex="0">
            {CK["get_entity.error.invalid_telephone"]}
          </div>

          <div className="error_message hide" id="invalid_email" tabIndex="0">
            {CK["get_entity.error.invalid_email"]}
          </div>

          <div className="error_message hide" id="email_does_not_match" tabIndex="0">
            {CK["get_entity.error.email_does_not_match"]}
          </div>

          <div className="error_message hide" id="err_agreement-accepted" tabIndex="0">
            {CK["get_entity.error.err_agreement_accepted"]}
          </div>

          <div className="error_message hide" id="err_confirm_authority" tabIndex="0">
            {CK["get_entity.error.err_confirm_authority"]}
          </div> */}

          {/* <ul className="hide" id="error_summary_template">
            <li className="error_summary_item">
              <a className="error_message error_summary_message" href="#"></a>
            </li>
          </ul> */}

          <div className="ontario-loading-indicator__container">
            {isLoading && <LoadingIndicator />}
          </div>

          <div className="ontario-row" style={{ marginTop: '1.5rem' }}>
              <button
                id="submit-button"
                onClick={handleOnSubmit}
                tabIndex={0}
                title={CK["footer.submit1"]}
                className="ontario-button ontario-button--primary"
              >
                {CK["footer.submit"]}
              </button>
          </div>
        </div>
        </>
        }
        <Footer />
      </div>
    );
  }

  export default SearchDetails;